import axios from 'axios';

const BASE_API = process.env.VUE_API_ROOT;

export default {
  getPackaging(items) {
    return axios({
      method: 'post',
      headers: { 'Content-Type': 'text/plain' },
      url: `${BASE_API}/shipping/package`,
      data: items,
    }).then(response => response.data)
      .catch((error) => {
        console.error(error);
        return [];
      });
  },
  getRates(payload) {
    return axios({
      method: 'post',
      headers: { 'Content-Type': 'text/plain' },
      url: `${BASE_API}/shipping/rates`,
      data: payload,
    }).then(response => response.data)
      .catch((error) => {
        console.error(error);
        return [];
      });
  },
}



// WEBPACK FOOTER //
// /src/services/shipping.js